import React from 'react';
import '../less/index.less';
import file_icon from '../img/file_icon.svg';

export default function template() {
  const { title, items, titleTag } = this.props;

  if (!items || items.length === 0) {
    return null;
  }

  const TitleTag = titleTag || "h2"

  return (
    <div className="files-local">
      <div className="container">
        <TitleTag className={`files-local__title`}>{this.l10n(title)}</TitleTag>
        {items.map((item, index) => {
          return (
              <div key={index} className="files__item item-files-local">
                <a href={item.link} target="_blank" rel="noopener noreferrer">
                  <div className="item-files-local__image">
                    <img src={file_icon} alt='doc-img'></img>
                  </div>
                  <div className="item-files-local__text">{this.l10n(item.text)}</div>
                </a>
              </div>
            )
          }
        )}
      </div>
    </div>
  );
}
